import axios from 'axios'
import { HookValidationParameters, HookValidationResult, Hook } from '../features/hook/types'

export const fetchHooks = () => axios.get('/hooks')

export const fetchHookInfo = (entityId: any) => axios.get<Hook>(`/hooks/${entityId}`)

export const validateHook = (hook: HookValidationParameters) =>
  axios.post<HookValidationResult>('/hooks/validate', hook)

export const saveHook = (hook: HookValidationParameters) => axios.post<Hook>('/hooks', hook)

export const updateHook = (entityId: number, data: HookValidationParameters) =>
  axios.put<Hook>(`/hooks/${entityId}`, data)

export const deleteHook = (entityId: number) => axios.delete(`/hooks/${entityId}`)
